import { combineReducers } from 'redux';
import settings from './settings/reducer';
import menu from './menu/reducer';
import authUser from './auth/reducer';
import trainerApp from './employers/reducer';
import employer from './employers/employer-reducer';
import client from './client/reducer';
import actionPlan from './action-plan/reducer';
import activity from './activity/reducer';
import event from './event/reducer';
import jobSeeker from './job-seeker/reducer';
import cojgContract from './contract/cojg/reducer';
import cheque from './contract/cojg/cheque-reducer';
import budget from './contract/budget/reducer';
import geography from './geography/reducer';
import shift from './shifts/reducer';
import jobtype from './job-type/reducer';
import sector from './sector/reducer';
import cojgFinancial from './report/cojg/reducer';
import contractsPaid from './report/contracts-paid/reducer';
import cojgFund from './report/cojg-fund/reducer';
import cojgReconciliation from './report/cojg-reconciliation/reducer';
import esContractReport from './report/es/reducer';
import allESContractOustanding from './report/all-es-contract-oustanding/reducer';
import role from './role/reducer';
import userList from './user/reducer';
import assessement from './assessement/reducer';
import clientAggregate from './client-aggregate/reducer';
import aggregate from './aggregate/reducer';
import notificationReport from './report/notification/reducer';
import clientFund from './client-fund/reducer';
import caseNote2 from './case-note2/reducer';
import resume from './resume/reducer';
import camsImport from './cams-import/reducer';
import employerCaseNote from './employer-case-note/reducer';
import todoApp from './todo/reducer';
import caseSummary from './case-summary/reducer';
import mileage from './mileage/reducer';
import expense from './expense/reducer';
import mileageEntry from './mileage-entry/reducer';
import expenseEntry from './expense-entry/reducer';
import mileageSetting from './mileage-setting/reducer';
import clientFundSetting from './client-fund-setting/reducer';
import cojgCaseNote from './cojg-case-note/reducer';
import seContract from './se-contract/reducer';
import esContract from './es-contract/reducer';
import iesContract from './ies-contract/reducer';
import document from './document/reducer';
import setting from './system-setting/reducer';
import esCheque from './es-cheque/reducer';
import seCheque from './se-cheque/reducer';
import esCaseNote from './es-case-note/reducer';
import seCaseNote from './se-case-note/reducer';
import mileageSupervisor from './mileage-supervisor/reducer';
import eventCalendar from './event-calendar/reducer';
import formDocument from './form-document/reducer';
import additionalInfo from './additional-info/reducer';
import site from './site/reducer';
import employmentEarning from './employment-earning/reducer';
import contact from './contact/reducer';
import posting from './posting/reducer';
import eventParticipant from './event-participant/reducer';
import cecContact from './cec-contact/reducer';
import cecList from './cec-list/reducer';
import yjcContract from './yjc-contract/reducer';
import yjcCheque from './yjc-cheque/reducer';
import yjcsContract from './yjcs-contract/reducer';
import yjcsCheque from './yjcs-cheque/reducer';
import prospectReceiveNotification from './prospect-receive-notification/reducer';
import servicePlan from './service-plan/reducer';
import alert from './alert/reducer';
import referral from './referral/reducer';
import clientFundSupervisor from './client-fund-supervisor/reducer';
import employmentActionPlan from './employment-action-plan/reducer';
import clientSupport from './client-support/reducer';
import employerDocument from './employer-document/reducer';
import outreach from './outreach/reducer';
import outcomes from './outcomes/reducer';
import subGoal from './sub-goal/reducer';
import clientSummary from './client-summary/reducer';
import financialTracking from './financial-tracking/reducer';
import jobMatching from './job-matching/reducer';
import interventionFollowupIES from './intervention-followup-ies/reducer';
import prospect from './prospect/reducer';
import eidm from './eidm/reducer';
import subGoalLBS from './subgoal-lbs/reducer';
import clientSummaryLBS from './client-summary-lbs/reducer';
import clientTSA from './client-tsa/reducer';
import ClientReferral from './client-referral/reducer';
import planContent from './plan-content/reducer';
import cojgContractDocument from './cojg-contract-document/reducer';
import clientCourse from './client-course/reducer';
import clientSummaryYJC from './client-summary-yjc/reducer';
import caseAudit from './case-audit/reducer';
import prospectHub from './prospect-hub/reducer';

const reducers = combineReducers({
  menu,
  settings,
  authUser,
  trainerApp,
  employer,
  contact,
  client,
  actionPlan,
  activity,
  event,
  jobSeeker,
  esContract,
  iesContract,
  cojgContract,
  cheque,
  budget,
  geography,
  shift,
  jobtype,
  sector,
  cojgFinancial,
  contractsPaid,
  cojgFund,
  cojgReconciliation,
  esContractReport,
  allESContractOustanding,
  role,
  userList,
  assessement,
  clientAggregate,
  aggregate,
  notificationReport,
  clientFund,
  caseNote2,
  resume,
  camsImport,
  employerCaseNote,
  todoApp,
  caseSummary,
  mileage,
  expense,
  mileageEntry,
  expenseEntry,
  mileageSetting,
  clientFundSetting,
  cojgCaseNote,
  seContract,
  document,
  setting,
  esCheque,
  seCheque,
  esCaseNote,
  seCaseNote,
  mileageSupervisor,
  eventCalendar,
  formDocument,
  additionalInfo,
  site,
  employmentEarning,
  posting,
  eventParticipant,
  cecContact,
  cecList,
  yjcContract,
  yjcCheque,
  yjcsContract,
  yjcsCheque,
  prospectReceiveNotification,
  servicePlan,
  alert,
  referral,
  clientFundSupervisor,
  employmentActionPlan,
  clientSupport,
  employerDocument,
  outreach,
  outcomes,
  subGoal,
  clientSummary,
  financialTracking,
  jobMatching,
  interventionFollowupIES,
  prospect,
  eidm,
  subGoalLBS,
  clientSummaryLBS,
  clientTSA,
  ClientReferral,
  clientCourse,
  planContent,
  cojgContractDocument,
  clientSummaryYJC,
  caseAudit,
  prospectHub,
});

export default reducers;
